export const getCookie = name => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
  return null;
};

export const setCookie = (name, value, expireDays) => {
  const d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};

export const removeCookie = name => {
  setCookie(name, '', 0);
};

export const sleep = async (duration = 1) =>
  new Promise(resolve => {
    setTimeout(resolve, duration);
  });

export const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export const getURLParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlParams);
};

export const setURLParams = params => {
  const urlParams = new URLSearchParams(window.location.search);

  Object.keys(params).forEach(key => {
    if (params[key]) urlParams.set(key, params[key]);
    else urlParams.delete(key);
  });

  const url = new URL(window.location);
  url.search = urlParams;

  window.history.pushState({}, '', url.href);
};

export const cloneDeep = obj => JSON.parse(JSON.stringify(obj));

export const snakeToCamel = s => s.replace(/(_\w)/g, k => k[1].toUpperCase());
export const kebabToCamel = s => s.replace(/(-\w)/g, k => k[1].toUpperCase());

export function fillZeros(str, size = 2) {
  str += '';
  while (str.length < size)
    str = '0' + str;
  return str;
}
